import type { TiersNames } from "../../TierPointsProgressBar";

export const LoyaltyTier = {
  Silver: "silver",
  Gold: "gold",
  Black: "black",
} as const;

export type LoyaltyTierName = (typeof LoyaltyTier)[keyof typeof LoyaltyTier];
export type CartOverviewTierNextTier = Exclude<LoyaltyTierName, typeof LoyaltyTier.Silver>;

export const DEFAULT_LOYALTY_TIER_NAMES: TiersNames = {
  [LoyaltyTier.Silver]: "Silver",
  [LoyaltyTier.Gold]: "Gold",
  [LoyaltyTier.Black]: "Black",
};
